/**
 * Souqli support contact details - single source of truth.
 *
 * Every place that shows a way to reach us (Help Centre, Contact page, footer,
 * order pages) imports from here, so updating a number or the hours is a
 * one-line change that propagates everywhere.
 */

export const SUPPORT_EMAIL = 'info@souqli.co.uk';

/**
 * Customer support phone number.
 *
 * NOTE: this is a PLACEHOLDER using an Ofcom-reserved fictional number
 * (020 7946 0xxx is set aside for drama/examples and never rings a real line).
 * Replace both values below with Souqli's real support number before launch.
 *   - _DISPLAY is what customers see.
 *   - _TEL is the E.164 value used in tel: links (digits and a leading +, no spaces).
 */
export const SUPPORT_PHONE_DISPLAY = '+44 20 7946 0000';
export const SUPPORT_PHONE_TEL = '+442079460000';

/** Human-readable opening hours, shown next to the phone number. */
export const SUPPORT_HOURS = '9am to 6pm, Monday to Friday (UK time)';

/** Short form for tight spaces. */
export const SUPPORT_HOURS_SHORT = 'Mon to Fri, 9am to 6pm UK';

/** Pre-built mailto: link with a Souqli subject tag. */
export function supportMailto(subject = 'Support request'): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`[Souqli] ${subject}`)}`;
}
